import { HttpErrorResponse } from '@angular/common/http';
import { SelectErrorCode, SelectErrorDTO } from '@shared/dto';

export const getErrorCode = (error: HttpErrorResponse): SelectErrorCode => {
  const errorCode = (error.error as Partial<SelectErrorDTO> | null | undefined)
    ?.error_code;

  return isValidErrorCode(errorCode)
    ? errorCode
    : SelectErrorCode.UNKNOWN_ERROR;
};

const isValidErrorCode = (errorCode: unknown): errorCode is SelectErrorCode => {
  return Object.values(SelectErrorCode).includes(errorCode as SelectErrorCode);
};
